import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

export default class extends Controller {
  static values = { url: String, syncOnConnect: { type: Boolean, default: true }, syncIf: String };

  connect() {
    this.source = this.element.querySelector("turbo-cable-stream-source");
    if (!this.source) return;

    this.everConnected = false;
    this.observer = new MutationObserver(() => this.handleConnection());
    this.observer.observe(this.source, { attributeFilter: ["connected"] });
    this.handleConnection();
  }

  disconnect() {
    this.observer?.disconnect();
  }

  handleConnection() {
    if (!this.source.hasAttribute("connected")) return;

    const reconnect = this.everConnected;
    this.everConnected = true;
    if (reconnect || this.syncOnConnectValue) this.sync();
  }

  sync() {
    if (this.syncIfValue && !document.querySelector(this.syncIfValue)) return;

    get(this.urlValue, { responseKind: "turbo-stream" }).catch(() => {});
  }
}
